import _ from 'lodash';
import { determineErrorFromResponse } from 'helpers/ContentHelper';
import { getCreditMemberId } from './BioHelpers';
import { FETCH_BIO_LANDING, FETCH_BIO_DETAIL, CLEAR_BIO_PAGES } from './BioActions';

const INITIAL_STATE = {
  cast: null,
  detail: null,
  related: null,
  seo: null,
  landingSeo: null,
  errors: null,
  profiles: null,
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  if (errors) {
    return {
      ...state,
      errors,
    };
  }
  const data = _.get(action, 'payload.data');
  const landingSeo = _.get(data, 'SEO');

  switch (action.type) {
    case FETCH_BIO_LANDING: {
      const cast = _.get(data, 'panels.member.0.items.member.0.credits.member', []);
      return {
        ...state,
        cast,
        landingSeo,
        errors: null,
      };
    }

    case FETCH_BIO_DETAIL: {
      const profiles = _.get(state, 'profiles', []);
      const seo = _.get(data, 'SEO');
      const member = _.get(data, 'panels.member.0.items.member.0');

      const related = _.get(data, 'panels.member.1.items.member');
      const memberId = getCreditMemberId({ member });

      const newProfiles = {
        ...profiles,
        [memberId]: {
          featured: member,
          related,
          seo,
        },
      };

      return {
        ...state,
        errors: null,
        profiles: newProfiles,
      };
    }
    case CLEAR_BIO_PAGES: {
      return {
        ...state,
        ...INITIAL_STATE,
      };
    }

    default:
      return state;
  }
}
